import React from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';

const InvestorAbout = React.lazy(() => import('components/Investor/investorAbout'));
const InvestorBanner = React.lazy(() => import('components/Investor/investorBanner'));
const InvestorInvRelContact = React.lazy(() => import('components/Investor/investorInvRelContact'));
const InvestorSpecialList = React.lazy(() => import('components/Investor/investorSpecialList'));
const InvestorTabData = React.lazy(() => import('components/Investor/investorTabData'));

const Investors: React.FC = () => {
  const location = useLocation();
  const About = location.hash === "#overview";
  const corp = location.hash === "#corpgove-tab-pane";
  const esg = location.hash === "#esg-tab-pane";
  //console.log(location.hash)
  return (
    <>
        <InvestorBanner /> 
      {About  ? (
        <InvestorAbout />
      ) : (
        <LazySection fallback={<SectionSkeleton height={300} />}>
          <InvestorAbout />
        </LazySection>
      )}

      {corp  ? (
        <InvestorTabData />
       ) : (
        <LazySection fallback={<SectionSkeleton height={350} />}>
        <InvestorTabData />
      </LazySection>
    )}
    
      {esg  ? (
        <InvestorSpecialList />
        ) : (
        <LazySection fallback={<SectionSkeleton height={350} />}>
        <InvestorSpecialList />
      </LazySection>
    )}
    
        <LazySection fallback={<SectionSkeleton height={350} />}>
          <InvestorInvRelContact />
        </LazySection>
    </>
  );
};

export default Investors;
